export default {

    init: function () {
        this.bindEvents();
        //on scroll, close desktop mega-menus
    },

    handleItemHover: function ($$) {
        // let anchor = $$.find('a');
        let hasSubmenu = $$.hasClass('has-children');

        if (!hasSubmenu) {
            console.log('no mega menu');
        }

        let targetID = $$.data('menu-parent');
        let targetMenu = $(`*[data-mega-menu="${targetID}"]`);

        if (targetMenu.hasClass('active')) return;

        $('.mega-menu.active')
            .fadeOut(200)
            .promise()
            .done(() => {
                $('.mega-menu.active').removeClass('active');
                //open the new menu
                this.showMegaMenu(targetMenu, $$);
            });

    },

    showMegaMenu: function (selector, activeMenuLink) {
        $('.mega-menus').addClass('active');
        $('.menu-item.active').removeClass('active');
        activeMenuLink.addClass('active');
        selector.addClass('active');
        $('.header').addClass('shadow');
        // let megaBackground = $('#mega-menu-background');
        //
        // megaBackground.stop().animate(
        //     {height: selector.height() + 'px'},
        //     Math.abs(megaBackground.height() - selector.height()));
    },

    closeAll: function () {

        $('.mega-menu')
            .fadeOut(200)
            .promise()
            .done(() => {
                $('.mega-menus').removeClass('active');
                $('.mega-menu').removeClass('active');
                $('.menu-item.active').removeClass('active');
            });

        $('.header').removeClass('shadow');
        //
        // $('#mega-menu-background').stop().animate({
        //     height: 0,
        // }, 200);
    },

    bindEvents: function () {
        let _this = this;
        let hoverDebounce = null;

        $('#desktop-main-navigation .menu-item').mouseenter(function () {

            let el = this;
            clearTimeout(hoverDebounce);
            hoverDebounce = setTimeout(function () {
                _this.handleItemHover($(el));
            }, 200);
        });

        $('.mega-menus .inner').mouseleave(function () {
            clearTimeout(hoverDebounce);
            hoverDebounce = setTimeout(function () {
                _this.closeAll();
            }, 200);
        });

        $(document).scroll(function () {
            _this.closeAll();
        });

        $('[data-highlight]').hover(
            function () {
                $('[data-highlight-target="' + $(this).data('highlight') + '"').addClass('show-highlight');
            },
            function () {
                $('[data-highlight-target="' + $(this).data('highlight') + '"').removeClass('show-highlight');
            });
    },
};